module.exports = __webpack_public_path__ + "static/img/logo_1.b896bda.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo_1.png
// module id = lUua
// module chunks = 0